/**
 * React Starter Kit (https://www.reactstarterkit.com/)
 *
 * Copyright © 2014-present Kriasoft, LLC. All rights reserved.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE.txt file in the root directory of this source tree.
 */

import React from 'react';
import withStyles from 'isomorphic-style-loader/lib/withStyles';
import s from './Header.css';
import Link from '../Link';
import Navigation from '../Navigation';
import HamburgerMenu from '../HamburgerMenu';
import logoUrl from './logo.svg';

class Header extends React.Component {
  render() {
    return (
      <div className={s.root}>
        <div className={s.container}>
          <div className={`${s.column} ${s.columnSpan35}`}>
            <Link className={`${s.link} ${s.flex}`} to="/">
              <img
                src={logoUrl}
                width="88"
                height="60"
                alt="Maybricks Sdn Bhd"
              />
              <div className={s.title}>
                <div className={s.titleCn}>大馬磚業有限公司</div>
                <div className={s.titleEn}>Maybricks Sdn Bhd</div>
              </div>
            </Link>
          </div>
          <div className={`${s.column} ${s.drawer}`}>
            <HamburgerMenu />
          </div>
          <div className={`${s.column} ${s.navigation}`}>
            <Navigation />
          </div>
        </div>
      </div>
    );
  }
}

export default withStyles(s)(Header);



// WEBPACK FOOTER //
// ./src/components/Header/Header.js